class CartNotification extends HTMLElement {
  connectedCallback() {
    if (this._ready) return;
    this._ready = true;

    this.notification = this.querySelector('.cart-notification');
    if (!this.notification) return;

    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener(
      'keyup',
      (evt) => evt.code === 'Escape' && this.close()
    );

    this.querySelectorAll('button[type="button"]').forEach((btn) =>
      btn.addEventListener('click', this.close.bind(this))
    );
  }

  openDrawer() {
    if (!this.notification) return;
    window.pauseAllMedia && window.pauseAllMedia();
    document.body.classList.add('overflow-hidden');
    this.notification.classList.add('animate', 'active');
    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        window.trapFocus && trapFocus(this.notification);
      },
      { once: true }
    );
    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    if (!this.notification) return;
    this.notification.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
    document.body.removeEventListener('click', this.onBodyClick);
    window.removeTrapFocus && removeTrapFocus(this.activeElement);
  }

  handleBodyClick(evt) {
    if (evt.target !== this.notification && !evt.target.closest('cart-notification')) {
      const disclosure = evt.target.closest('details-disclosure');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }
}

customElements.define('cart-notification', CartNotification);

// ── Module-level cart trigger — runs once regardless of section instances ──
(function () {
  if (window._swCartTriggerReady) return;
  window._swCartTriggerReady = true;

  function isInVisibleSection(el) {
    if (!el) return false;
    const section = el.closest('.shopify-section');
    if (!section) return true;
    return window.getComputedStyle(section).display !== 'none';
  }

  function getDrawer() {
    const all = document.querySelectorAll('cart-notification');
    for (const el of all) {
      if (isInVisibleSection(el)) return el;
    }
    return all[0] || null;
  }

  function fetchAndPopulate() {
    const drawer = getDrawer();
    if (!drawer) return;
    const container = drawer.querySelector('.cart-notification-product');
    if (!container) return;

    fetch('/cart')
      .then((r) => r.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const sectionEl = doc.querySelector('#main-cart');
        const contentsEl = doc.querySelector('.js-contents');
        if (sectionEl) {
          container.innerHTML = sectionEl.outerHTML;
        } else if (contentsEl) {
          container.innerHTML = contentsEl.innerHTML;
        }
        if (sectionEl || contentsEl) {
          container.querySelectorAll('.critical-hidden').forEach(function (node) {
            node.classList.remove('critical-hidden');
          });
        }
      });
  }

  fetchAndPopulate();

  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-sw-open-cart]')) return;
    e.preventDefault();
    e.stopPropagation();
    const drawer = getDrawer();
    if (drawer) drawer.openDrawer();
    fetchAndPopulate();
  });

  window.swCartDrawer = {
    open: function () {
      const drawer = getDrawer();
      if (drawer) {
        drawer.openDrawer();
        fetchAndPopulate();
      }
    },
    close: function () {
      const drawer = getDrawer();
      if (drawer) drawer.close();
    },
  };

  document.addEventListener('cart:updated', function () {
    fetch('/cart')
      .then((r) => r.text())
      .then((html) => {
        const bubble = document.getElementById('cart-icon-bubble');
        if (!bubble) return;
        const el = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
        if (el) bubble.innerHTML = el.innerHTML;
      });
  });
})();
